import getYearlyReviewWrapped from 'api/v2/shared/getYearlyReviewWrapped';
import CustomLoader from 'components/molecules/CustomLoader.component';
import { useYearlyReviewAiMetadata } from 'contexts/AIMetadataProvider/useYearlyReviewAiMetadata';
import { useState, type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { YearlyReviewCacheKeys } from 'types/cacheKeys.types';
import AIChatYearly from './sections/AIChatYearly/AIChatYearly.component';
import DeductibleExpensesSection from './sections/DeductibleExpenses/DeductibleExpensesSection.component';
import EarningsSection from './sections/EarningsSection.component';
import FooterText from './sections/FooterText.component';
import QuartersSummarySection from './sections/QuartersSummarySection.component';
import WelcomeBanner from './sections/WelcomeBanner.component';
import WelcomeText from './sections/WelcomeText.component';
import SectionTitle from './SectionTitle';

const YearlyReview: FC = () => {
  const { t } = useTranslation();

  const { data, isLoading, isRefetching } = useQuery(
    YearlyReviewCacheKeys.YearlyReviewData,
    getYearlyReviewWrapped,
    { staleTime: 0 },
  );

  useYearlyReviewAiMetadata(data);

  const [rejectedConsent, setRejectedConsent] = useState(false);

  if (isLoading || isRefetching)
    return (
      <div className="h-screen flex items-center justify-center">
        <CustomLoader />;
      </div>
    );

  return (
    <div className="rounded-lg w-full bg-white font-gotham max-w-[1048px] px-10 pt-10 mt-[-40px] mx-auto shadow-[0px_0px_4px_0px_#351A4D14]">
      <WelcomeBanner />

      <WelcomeText />

      <AIChatYearly
        rejectedConsent={rejectedConsent}
        setRejectedConsent={setRejectedConsent}
      />

      <SectionTitle
        title={t('yearly_review.earnings_section.title')}
        className="my-8"
      />

      <EarningsSection data={data} />

      <DeductibleExpensesSection
        data={data}
        rejectedConsent={rejectedConsent}
        setRejectedConsent={setRejectedConsent}
      />

      <SectionTitle
        title={t('yearly_review.quarters_widget.title')}
        className="my-8"
      />

      <QuartersSummarySection data={data} />

      <FooterText />
    </div>
  );
};

export default YearlyReview;
